import React from "react";
import { useTranslation } from 'react-i18next';
import InvoiceNumberSettings from "../components/InvoiceNumberSettings";
import InvoiceDateSettings from "../components/InvoiceDateSettings";
import { Col, Row } from "react-bootstrap";


const SettingsPage: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <div >
      <Row>
        <Col>
            <h1 id='invoiceNumber'>{t('invoiceSettings')}</h1>
            <InvoiceNumberSettings  />
            <InvoiceDateSettings/>        
        </Col>
      </Row>
      
    </div>
    
  );
};

export default SettingsPage;
